// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/list-plus.js';

import { paths } from '../generated/list-plus';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('list-plus', Original, paths);
